
















import Vue, { PropType } from 'vue';

const colorType = ['white', 'red', 'blue', 'light-blue', 'orange', 'dark', 'gray'];

export default Vue.extend({
  name: 'GTag',
  props: {
    color: {
      type: String as PropType<string>,
      default: 'white',
      validator: (prop: string) => colorType.includes(prop),
    },
  },
});
